import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_PAYMENT_MASTER, GET_ALL_SUPPLIER_CERTIFICATE_MASTER } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";




export function fetchAllCategoryMaster(categorytypeID) {
    return (dispatch) => {
        // const certificateTypeID =id;
        const request = axiosHelper.get(APIUSEROLD.getAllCategoryMaster, {
            params: {
                SupplierCategoryId: categorytypeID?.CertificateTypeID
            }
        });

        request
            .then((response) => {

                if (response?.data || response.status === 204) {
                    dispatch({
                        type: GET_ALL_SUPPLIER_CERTIFICATE_MASTER,
                        payload: {
                            data: response.status === 204 ? [] : response?.data,
                        },
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE });
                if (error.response.status === 401) {
                    apiErrors(error)
                } 
            });
    };
}
export function getSupplierCategoryById(id) {
    const request = axiosHelper.get(`${APIUSEROLD.getCategoryDetailById}?SupplierCategoryId=${id}`);
    return request
        .then((response) => {
            if (response.Data) {
                // You can perform additional actions if needed
            }
            return response; // Return the response to the caller
        })
        .catch((error) => {
            if (error.response.status === 401) {
                apiErrors(error)
            } else{

                throw error; // Re-throw the error to the caller
            }
            // apiErrors(error);
        });
}
export function getAllDepartmentMaster() {

    const request = axiosHelper.get(`${APIUSEROLD.getAllDepartmentMaster}`);
    return request
        .then((response) => {
            if (response.data.Result) {

                // You can perform additional actions if needed
            }

            return response?.data; // Return the response to the caller
        })
        .catch((error) => {
            // apiErrors(error);
            if (error.response.status === 401) {
                apiErrors(error)
            } else{

                throw error; // Re-throw the error to the caller
            }
        });
}
export function saveSupplierCategory(data, callback) {
    return (dispatch) => {
        //dispatch({ type: API_REQUEST });
        const request = axiosHelper.post(APIUSEROLD.saveSupplierMaster, data)
        request
            .then((response) => {
                if (response.data) {
                    callback(response?.data)
                }
            })
            .catch((error) => {
                dispatch({ type: API_FAILURE })
                if (error.response.status === 401) {
                    apiErrors(error)
                } 
                // apiErrors(error)
                // callback(error);
            })
    }
}